module.exports = __webpack_public_path__ + "img/404.678f0d2a.jpg";